import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ConfirmationModal } from "../../../../../../layout/Modal/ConfirmationModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import {
  deleteGroup as deleteGroupApi
} from "../../../../../../../api/admin/groups";
import { Link } from "react-router-dom";
import { NOTIFICATION_ADMIN_GROUP_ACTIONS } from '../../../../../../../config/notifications';
import { ACL } from '../../../../../../../config/constants/UogACL/ACL';
import { store } from '../../../../../../../store/store';
import { hideNotification } from '../../../../../../../store/actions/notification';

function DeleteGroup(props) {
  const [ showDeleteModal, setShowDeleteModal ] = useState( false );
  const { index, actionCallback, group, showIcon } = props;

  if (! ACL.ADMIN.GROUPS.DELETE.hasAccess()) {
    return null;
  }

  const deleteGroup = () => {
    deleteGroupApi( {
      groupId: group.id,
      notificationId: NOTIFICATION_ADMIN_GROUP_ACTIONS
    } ).then( (response) => {
      setShowDeleteModal( false );

      if (response && response.status === 204) {
        actionCallback();
      }
    } );
  };

  return ( <Fragment>
      {! showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`delete-icon-${index}`}
            onClick={() => {
              store.dispatch(hideNotification());
              setShowDeleteModal( true )
            }}
          >
            <FormattedMessage
              id="components.pages.admin.groups.table.actionButtons.delete_group"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`delete-icon-${index}`}
            modifiers={{
              preventOverflow: {
                enabled: true,
                boundariesElement: "body",
              },
            }}
          >
            <FormattedMessage
              id="components.pages.admin.groups.table.actionButtons.delete_group"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`delete-icon-` + props.index}
            onClick={() => setShowDeleteModal( true )}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faTrash}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`delete-icon-${props.index}`}
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
          >
            <FormattedMessage
              id="components.pages.admin.groups.table.actionButtons.delete_group"/>
          </UncontrolledTooltip>
        </Fragment>
      }

      <ConfirmationModal
        showModal={showDeleteModal}
        closeModal={() => setShowDeleteModal( false )}
        confirmationYes={deleteGroup}
      />
    </Fragment>
  );
}

export { DeleteGroup };
